import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  Chip,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { useEffect, useState } from "react";

export const TodoTabFixes = () => {
  const [fixes, setFixes] = useState([]);

  const traerArreglos = async () => {
    try {
      const response = await fetch(`/api/v1/buzon?type=arreglo`);
      const data = await response.json();

      if (!data.ok) {
        return;
      }

      //Darle formato a los datos
      data.data.forEach((fix) => {
        fix.relevance = relevance[fix.relevance];
        fix.status = status[fix.status];
      });

      setFixes(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    traerArreglos();
  }, []);

  if (fixes.length === 0) {
    return (
      <Typography variant="body2" color="textSecondary">
        No hay arreglos
      </Typography>
    );
  }

  return (
    <>
      {fixes.map((fix) => (
        <Accordion key={fix.id}>
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Typography variant="subtitle1">{fix.title}</Typography>
              <Typography variant="body2" color="textSecondary">
                {new Date(fix.date).toLocaleDateString()}
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2" color="textSecondary">
              {fix.description}
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 2,
              }}
            >
              <Chip label={fix.status.name} color={fix.status.color} />
              <Chip label={fix.relevance.name} color={fix.relevance.color} />
            </Box>
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
};
